
import { BasicResult } from "../basic-result";
import { Campaign } from "./campaign";

export class CampaignListResult extends BasicResult {
    public Campaigns: Campaign[] = [];

    constructor(values: Object = {}) {
        super();
        Object.assign(this, values);
        if (values.hasOwnProperty('Campaigns')) {
            this.Campaigns = [];
            ((values as CampaignListResult)['Campaigns'] as Campaign[]).forEach(element => {
                this.Campaigns.push(new Campaign(element));
            });
        }


    }
}